import { createFileRoute } from '@tanstack/react-router';
import { SocialPostsManager } from '../../components/admin/SocialPostsManager';

export const Route = createFileRoute('/admin/social-posts')({
  component: SocialPostsTab,
});

function SocialPostsTab() {
  return <SocialPostsManager />;
}
